import { render, staticRenderFns } from "./TbcAccept.vue?vue&type=template&id=0ea4ad10&"
import script from "./TbcAccept.vue?vue&type=script&lang=js&"
export * from "./TbcAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports